import { SlideComponentAudio } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentAudioCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentAudio {
        return {
            id: id,
            type: 'audio',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 100, height: 100 },
            content: {
                audio: [],
            },
        };
    }
}
